export default (function (dataLayer) {
  if (dataLayer === void 0) {
    dataLayer = {};
  }
  if (Object.entries(dataLayer).length === 0) {
    return dataLayer;
  }
  return {
    vehicleId: `${dataLayer.vehicle?.id}`,
    vin: dataLayer.vehicle?.vin,
    year: dataLayer.vehicle?.year,
    make: (`${dataLayer.vehicle?.make}` || '').toLowerCase(),
    model: (`${dataLayer.vehicle?.model}` || '').toLowerCase(),
    price: dataLayer.vehicle?.pricingDetail?.salePrice,
    odometer: `${(`${dataLayer.vehicle?.mileage?.value}` || '').replace(/[^0-9.]*/g, '')} mi`,
    stockNumber: dataLayer.vehicle?.stockNumber,
    vehicleType: (`${dataLayer.vehicle?.listingType}` || '').toLowerCase(),
    exteriorColor: (`${dataLayer.vehicle?.color?.exteriorColor}` || '').toLowerCase(),
    fuelEconomy: `${dataLayer.vehicle?.mpgCity} mpg city,${dataLayer.vehicle?.mpgHighway} mpg hwy`,
    listingCode: dataLayer.vehicle?.owner?.id,
    zipCode: dataLayer.user?.zipCode
  };
});